export default "__VITE_ASSET__CVbHSHXd__"